//
//
//
//
//
//
//
export default {
  name: 'fileLoading',
  props: ["percentName"],
  data: function data() {
    return {
      percenNum: 0
    };
  },
  computed: {
    haha: function haha() {
      this.percenNum = Math.round(this.$store.state.progressNum * 100);
      return this.percenNum;
    }
  },
  methods: {},
  watch: {
    haha: function haha(val, newval) {
      this.percenNum = Math.round(newval * 100);

      if (this.percenNum > 50) {
        this.percenNum = 100;
      }
    }
  }
};